let imgBaseUrl = "";
let apiBaseUrl = "";
if (location.hostname == "localhost") {
  imgBaseUrl = "https://wonders.yun.liuzhou.gov.cn";
  apiBaseUrl = "/imgapi/";
} else if (location.hostname == "127.0.0.1") {
  imgBaseUrl = "https://wonders.yun.liuzhou.gov.cn";
  apiBaseUrl = "/imgapi/";
} else {
  imgBaseUrl = `https://${location.hostname}`;
  apiBaseUrl = `https://${location.hostname}/`;
}

export default {
  imgBaseUrl: imgBaseUrl,
  apiBaseUrl: apiBaseUrl
};
